import {
    Button,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    MenuItem,
    MuiThemeProvider,
    Paper,
    Select,
    TextField,
    Typography
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import Pagination from '@material-ui/lab/Pagination';
import cs from 'classnames';
import { validateWriteAccess } from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import {
    isBlank,
    isEmptyList,
    isEmptyObject,
    isNotBlank,
    isNotEmptyList,
    isNotEmptyObject
} from 'components/Common/Utils/StringUtils';
import Header from 'components/Header/Header';
import * as actions from 'components/TrustCenter/store/actions/index';
import baseCSS from 'components/TrustCenter/TrustCenter.module.css';
import { PRIMARY_BUTTON_LIGHT_OUTLINE_THEME } from 'components/UI/Button/ButtonMuiTheme';
import Spinner from 'components/UI/Spinner/Spinner';
import * as Constants from 'constants/Constants';
import {
    CREATE_CONNECTION,
    ROWS_PER_PAGE_AGREEMENTS,
    SHARING_AGREEMENT_STATUS,
    SUPPORT_USER,
    SYSTEM_ADMIN,
    VISIBILITY_ADMIN
} from 'constants/Constants';
import Auxiliary from 'hoc/Auxiliary';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setCurrentPage } from 'store/actions';
import { MACROPOINT } from '../store/actions/types';
import {
    FILLED_INPUT_FIELD_THEME,
    PrimarySwitch,
    SEARCH_BAR_THEME,
    STD_INPUT_FIELD_THEME
} from '../TrustCenterMuiTheme';
import Agreement from './Agreement/Agreement';
import CarrierConfig from './Agreement/CarrierConfig/CarrierConfig';
import Styles from './ProviderDetail.module.css';
import {
    resetV2AgreementsList,
    getV2SharingAgreementById
} from '../store/actions/agreementV2Action';
import { PrimaryTextField } from 'theme/CommonTheme';
import SharingAgreementDetailV2 from './SharingAgreementV2';
import { SHOW_SUCCESS_BAR } from 'store/actions/types';
import {
    CARRIER_AGREEMENT_SURFACES,
    getCarrierAgreementSurfaces,
    hasCarrierSurface,
    isCarrierAgreementContext,
    isLegacyCarrierV1ChildRoute,
    isCarrierV2Route
} from '../carrierAgreementSurfaces';

const ProviderDetail = (props) => {
    const {
        session,
        agreements,
        searchText,
        mobilityData,
        sidebarResource,
        dataSource,
        getDataSource,
        getMobilityData,
        fetchAgreements,
        updateFilteredAgreements,
        getConnectionsByProviderId,
        selectedConnection,
        selectedProvider,
        getProviderDetails,
        setCurrentPage,
        showAgreementCreation,
        toggleCreateConnection,
        getConnectionById,
        visibilityProvider,
        resetConnection,
        showSpinner,
        enableOperation,
        newShipperAgreement,
        existingAgreementGroup,
        editedAgreements,
        resetUserInputs,
        updateScrollIntoGroup,
        updateSearchText,
        isAgreementInEditMode,
        currentOperation,
        newTruckAgreements,
        updateVisibilityConnectionStatus,
        disableOtherOperation,
        disableConnectionSwitch,
        agreementSaved,
        newConnectionId,
        storeNewConnectionId,
        toggleAgreementSaveFlag,
        visibilityProviderFlag,
        parentPage,
        isProviderConnectionLoaded,
        isEmptyAgreements,
        setEmptyAgreements,
        setCloseAllPanel,
        getTrustCenterEventTypes,
        currentAccountType,
        updateCurrentAccountType,
        connectionType,
        updateConnectionType,
        selectedAccount,
        carrierConfigExist,
        agreementV2List: agreementsV2,
        isTitanServiceEnabled,
        sharingAgreementsV2,
        providers,
        providerConfigV2,
        createV2SharingAgreement,
        updateV2SharingAgreement,
        getProvidersV2,
        showSuccessBar,
        getSharingAgreementV2ById,
        selectedV2SharingAgreement,
        setSelectedV2SharingAgreement,
        selectedProviderId,
        isCloudHubConnectorActive,
        isCloudHubConnectorStatusLoaded,
        getCloudHubConnectorStatus
    } = props;

    const [connectionStatus, setConnectionStatus] = useState(true);

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    const [enableConnectionAction, setEnableConnectionAction] = useState(false);

    const [showSearchBar, setShowSearchBar] = useState(false);

    const [agreementData, setAgreementData] = useState(agreements);

    const [hideLocalElement, setHideLocalElements] = useState(false);
    const [eventsLoaded, setEventsLoaded] = useState(false);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );
    }, [sidebarResource]);

    let providerId = props.match.params.providerId;

    let providerV2AccountId = props.match.params.providerAccountId;

    var accountType = props.match.params.type;

    let connection_id;
    let isSystemAdmin = session.userRole === SYSTEM_ADMIN;
    const isVisibilityAdmin = session.userRoles?.includes(VISIBILITY_ADMIN);

    const isVisibilityProvider =
        session?.userRole === Constants.VISIBILITY_PROVIDER ||
        session?.accountType?.includes(Constants.VISIBILITY_PROVIDER);
    const visibilityProviderAgreementId = props.match.params.sharingAgreementId;
    const redirectVisibilityProviderToInbox =
        isVisibilityProvider &&
        !session?.isCarrier &&
        isNotBlank(visibilityProviderAgreementId) &&
        (props.location?.pathname || '').startsWith('/provider-summary/v2/agreements/');
    const carrierContext = isCarrierAgreementContext(session, selectedAccount);
    const isCarrierV2AgreementRoute = isCarrierV2Route(props.location?.pathname || '');
    const carrierAgreementSurfaces = getCarrierAgreementSurfaces({
        isCarrierContext: carrierContext,
        isTitanServiceEnabled,
        isCloudHubConnectorActive
    });
    const carrierAvailabilityReady =
        !carrierContext || !isTitanServiceEnabled || isCloudHubConnectorStatusLoaded;
    const cloudHubConnectorAccountId =
        isSystemAdmin && selectedAccount?.id ? selectedAccount.id : session.accountUuid;
    const hasCarrierV2Surface = hasCarrierSurface(
        carrierAgreementSurfaces,
        CARRIER_AGREEMENT_SURFACES.V2
    );
    const hasCarrierV1Surface = hasCarrierSurface(
        carrierAgreementSurfaces,
        CARRIER_AGREEMENT_SURFACES.V1
    );
    const isV2AgreementSurface = isCarrierV2AgreementRoute || !isTitanServiceEnabled;

    useEffect(() => {
        const roleName = session.userRole;
        setHideLocalElements(
            (!isWriteAccessGranted && (roleName === SYSTEM_ADMIN || roleName === SUPPORT_USER)) ||
            isV2AgreementSurface
        );
    }, [session.userRole, isWriteAccessGranted, isV2AgreementSurface]);

    if (isSystemAdmin && !isV2AgreementSurface) {
        connection_id = props.match.params.id;
    } else if (props.match.params.id && !isV2AgreementSurface) {
        connection_id = props.match.params.id;
        if (isBlank(accountType)) {
            accountType = props.match.params.type;
        }
    }
    useEffect(() => {
        if (isNotBlank(accountType) && isNotBlank(providerId)) {
            let type = getAccountType(accountType);
            updateCurrentAccountType(type);
            if (type.toLowerCase() === Constants.ACCOUNT_TYPE_SHIPPER.toLowerCase()) {
                updateConnectionType(Constants.AGREEMENT_SHIPPER);
            }
            if (!eventsLoaded) {
                let eventType = getTrustCenterAccountType(type);
                getTrustCenterEventTypes(eventType, providerId);
                setEventsLoaded(true);
            }
        }
    }, [updateCurrentAccountType, accountType]);

    useEffect(() => {
        setCurrentPage(isV2AgreementSurface ? Constants.CONNECTIONS_V2 : CREATE_CONNECTION);
        updateConnectionType('');
    }, [setCurrentPage, isV2AgreementSurface]);

    useEffect(() => {
        if (!showAgreementCreation) {
            if (currentAccountType.toLowerCase() !== Constants.ACCOUNT_TYPE_SHIPPER.toLowerCase()) {
                updateConnectionType('');
            }
        }
    }, [showAgreementCreation]);

    useEffect(() => {
        if (isNotBlank(providerId)) {
            let type = getAccountType(accountType);
            updateCurrentAccountType(type);
            if (type.toLowerCase() === Constants.ACCOUNT_TYPE_SHIPPER.toLowerCase()) {
                updateConnectionType(Constants.AGREEMENT_SHIPPER);
            }
            getConnectionsByProviderId(providerId, type, session);
        }
    }, [getConnectionsByProviderId]);

    const [providerName, setProviderName] = useState('');
    const [providerRequestStatus, setProviderRequestStatus] = useState('PENDING');

    const showCarrierConfig = () => {
        return [Constants.FOURKITES, MACROPOINT].includes(providerName);
    };
    useEffect(() => {
        if (isNotBlank(connection_id) && !isV2AgreementSurface) {
            getConnectionById(connection_id);
        }
    }, [connection_id, getConnectionById, isV2AgreementSurface]);

    useEffect(() => {
        if (isNotBlank(providerId)) {
            if (isProviderConnectionLoaded) {
                if (Object.keys(selectedConnection).length === 0) {
                    getProviderDetails(providerId);
                } else {
                    setProviderName(selectedConnection.name);
                    props.history.push(
                        `/connections/${selectedConnection?.id}/${selectedConnection?.name}/agreements`
                    );
                }
            }
        }
        if (isNotEmptyList(Object.keys(selectedConnection))) {
            let type = getAccountType(selectedConnection.type);
            updateCurrentAccountType(type);
            if (type.toLowerCase() === Constants.ACCOUNT_TYPE_SHIPPER.toLowerCase()) {
                updateConnectionType(Constants.AGREEMENT_SHIPPER);
            }
            if (!eventsLoaded) {
                let eventType = getTrustCenterAccountType(type);
                getTrustCenterEventTypes(eventType, selectedConnection.provider_id);
                setEventsLoaded(true);
            }
            if (isEmptyList(Object.keys(agreements))) {
                setConnectionStatus(true);
            } else {
                setConnectionStatus(selectedConnection.status);
            }
        }
    }, [selectedConnection, isProviderConnectionLoaded]);

    useEffect(() => {
        if (agreementSaved && isNotBlank(newConnectionId)) {
            toggleAgreementSaveFlag(false);
            storeNewConnectionId('');
            props.history.push(
                `/connections/${newConnectionId}/${selectedProvider?.name}/agreements`
            );
        }
        // else if (agreementSaved && isNotBlank(selectedProviderId)) {
        //     toggleAgreementSaveFlag(false);
        //     props.history.push(`/provider-summary/v2/${selectedProviderId}/agreements`);
        // }
    }, [agreementSaved, toggleAgreementSaveFlag, newConnectionId]);

    useEffect(() => {
        if (isEmptyList(Object.keys(selectedConnection))) {
            setConnectionStatus(true);
        } else if (isNotEmptyList(Object.keys(agreements))) {
            setConnectionStatus(findAgreementStatus(agreements));
        }
        setAgreementData(agreements);
        setShowSearchBar(false);
    }, [agreements]);

    const findAgreementStatus = (agree) => {
        let status = false;
        Object.values(agree).forEach((key) => {
            if (Object.values(key)[0].status) {
                status = true;
                return status;
            }
        });
        return status;
    };

    const getAccountType = (accountType) => {
        if (accountType.toLowerCase() === Constants.ACCOUNT_TYPE_SHIPPER.toLowerCase()) {
            return Constants.ACCOUNT_TYPE_SHIPPER.toUpperCase();
        } else if (
            accountType.toLowerCase() === Constants.AGREEMENT_TYPE_VISIBILITY_UI.toLowerCase()
        ) {
            return Constants.ACCOUNT_TYPE_VISIBILITY.toUpperCase();
        } else {
            return accountType.toUpperCase();
        }
    };

    const getTrustCenterAccountType = (type) => {
        if (type.toLowerCase() === Constants.AGREEMENT_TYPE_VISIBILITY.toLowerCase()) {
            return Constants.AGREEMENT_TYPE_VISIBILITY_UI.toLowerCase();
        } else {
            return type.toLowerCase();
        }
    };

    const enableConnectionOperation = (status) => {
        setEnableConnectionAction(status);
    };

    useEffect(() => {
        return () => {
            resetConnection();
            toggleCreateConnection(false);
            resetUserInputs();
            if (parentPage === Constants.ACCOUNT_DETAILS) {
                visibilityProviderFlag(false);
            }
            resetV2AgreementsList();
        };
    }, []);

    useEffect(() => {
        if (isNotBlank(selectedProvider.name)) {
            setProviderName(selectedProvider.name);
            setProviderRequestStatus(selectedProvider.request_status);
        }
    }, [selectedProvider]);

    useEffect(() => {
        if (isNotBlank(connection_id) && !isV2AgreementSurface) {
            fetchAgreements(connection_id, selectedAccount);
        }
    }, [connection_id, fetchAgreements, isV2AgreementSurface]);

    useEffect(() => {
        if (
            isNotBlank(providerV2AccountId) &&
            isV2AgreementSurface &&
            isNotEmptyList(providers)
        ) {
            const providerAccount = providers?.find(
                (provider) => provider.providerId === providerV2AccountId
            );
            setProviderName(providerAccount?.providerName);
        }
    }, [providers, providerV2AccountId, isV2AgreementSurface]);

    useEffect(() => {
        if (isNotBlank(connection_id)) {
            setProviderName(visibilityProvider.name);
            setProviderRequestStatus(visibilityProvider.request_status);
        }
    }, [visibilityProvider]);

    useEffect(() => {
        if (
            !isV2AgreementSurface &&
            dataSource.length <= 0 &&
            isWriteAccessGranted &&
            session.isTenantIdMapped
        ) {
            getDataSource();
        }
    }, [getDataSource, isWriteAccessGranted, isV2AgreementSurface]);

    useEffect(() => {
        if (mobilityData.length <= 0 && isWriteAccessGranted && session.isCompanyIdMapped) {
            getMobilityData();
        }
    }, [getMobilityData, isWriteAccessGranted]);

    const [paginatedAgreements, setPaginatedAgreements] = useState([]);
    let tempPaginatedAgreements = [];
    useEffect(() => {
        if (isNotEmptyObject(Object.keys(agreementData))) {
            Object.keys(agreementData).forEach((agreementData, index) => {
                if (index < ROWS_PER_PAGE_AGREEMENTS) {
                    tempPaginatedAgreements.push(agreementData);
                }
            });
            setPaginatedAgreements(tempPaginatedAgreements);
        }
    }, [agreementData]);

    useEffect(() => {
        if (isEmptyAgreements && isEmptyList(Object.keys(agreements))) {
            setEmptyAgreements(false);
            props.history.push('/connections');
        }
        setEmptyAgreements(false);
    }, [isEmptyAgreements]);

    useEffect(() => {
        if (
            carrierContext &&
            isTitanServiceEnabled &&
            !isCloudHubConnectorStatusLoaded &&
            isNotBlank(cloudHubConnectorAccountId)
        ) {
            getCloudHubConnectorStatus(cloudHubConnectorAccountId);
        }
    }, [
        carrierContext,
        isTitanServiceEnabled,
        isCloudHubConnectorStatusLoaded,
        cloudHubConnectorAccountId,
        getCloudHubConnectorStatus
    ]);

    useEffect(() => {
        if (!redirectVisibilityProviderToInbox) {
            return;
        }
        props.history.replace({
            pathname: `/sharing-agreements/${visibilityProviderAgreementId}`,
            search: '?source=v2',
            state: props.location?.state
        });
    }, [
        redirectVisibilityProviderToInbox,
        visibilityProviderAgreementId,
        props.history,
        props.location?.state
    ]);

    useEffect(() => {
        if (!carrierContext || !carrierAvailabilityReady) {
            return;
        }
        const pathname = props.location?.pathname || '';
        const search =
            isSystemAdmin && selectedAccount?.id
                ? `?accountId=${selectedAccount.id}`
                : props.location.search || '';
        if (isLegacyCarrierV1ChildRoute(pathname)) {
            if (!hasCarrierV1Surface && hasCarrierV2Surface) {
                props.history.replace({ pathname: Constants.ROUTES.CONNECTIONS_V2, search });
            }
            return;
        }
        if (isCarrierV2AgreementRoute) {
            if (!hasCarrierV2Surface) {
                props.history.replace({ pathname: Constants.ROUTES.CONNECTIONS, search });
            }
            return;
        }
        if (!pathname.startsWith('/provider-summary/v2')) {
            return;
        }
        if (!hasCarrierV2Surface) {
            props.history.replace({ pathname: Constants.ROUTES.CONNECTIONS, search });
            return;
        }
        const sharingAgreementId = props.match.params.sharingAgreementId;
        const providerAccountId = props.location?.state?.newAgreementProviderAccount;
        if (isNotBlank(sharingAgreementId)) {
            props.history.replace({
                pathname: `${Constants.CARRIER_V2_AGREEMENTS_PATH}/${sharingAgreementId}`,
                search,
                state: props.location.state
            });
        } else if (isNotBlank(providerAccountId)) {
            props.history.replace({
                pathname: `${Constants.CARRIER_V2_PROVIDER_PATH}/${providerAccountId}/create`,
                search,
                state: props.location.state
            });
        } else {
            props.history.replace({ pathname: Constants.ROUTES.CONNECTIONS_V2, search });
        }
    }, [
        carrierContext,
        carrierAvailabilityReady,
        hasCarrierV1Surface,
        hasCarrierV2Surface,
        isSystemAdmin,
        selectedAccount?.id,
        props.location,
        props.match.params.sharingAgreementId,
        props.history
    ]);

    const handleChange = (event) => {
        setCloseAllPanel(false);
        updateScrollIntoGroup('');
        updateConnectionType(event.target.value);
    };

    const handleSearch = (event) => {
        let filteredAgreements = {};
        const searchVal = event.target.value;
        updateSearchText(event.target.value.trim().toLowerCase());
        Object.keys(agreements).forEach((key) => {
            const actualValue = searchVal.toLowerCase().trim();
            let tagree = agreements[key].filter((element) => {
                var status = element.status ? 'active' : 'inactive';
                return (
                    key.toLowerCase().includes(actualValue) ||
                    status.startsWith(actualValue) ||
                    (element.agreement_type === 'MOB'
                        ? element.truck_number.toLowerCase().includes(actualValue)
                        : element.shipper_code.toLowerCase().includes(actualValue) ||
                        element.name.toLowerCase().includes(actualValue))
                );
            });
            if (isNotEmptyList(tagree)) filteredAgreements[key] = tagree;
        });
        setAgreementData(filteredAgreements);
        updateFilteredAgreements(filteredAgreements);
        Object.keys(filteredAgreements).forEach((agreementData, index) => {
            if (index < ROWS_PER_PAGE_AGREEMENTS) {
                tempPaginatedAgreements.push(agreementData);
            }
        });
        setPaginatedAgreements(tempPaginatedAgreements);
    };

    const handlePageChange = (event, value) => {
        if (isNotEmptyObject(Object.keys(agreementData))) {
            Object.keys(agreementData).forEach((agreementData, index) => {
                if (
                    index > value * ROWS_PER_PAGE_AGREEMENTS - (ROWS_PER_PAGE_AGREEMENTS + 1) &&
                    index < ROWS_PER_PAGE_AGREEMENTS * value
                ) {
                    tempPaginatedAgreements.push(agreementData);
                }
            });
            setPaginatedAgreements(tempPaginatedAgreements);
        }
    };

    const clearSearchAndReset = (searchBarFlag) => {
        if (searchBarFlag) {
            setShowSearchBar(false);
            updateSearchText('');
            if (isEmptyList(Object.keys(agreements))) {
                setConnectionStatus(true);
            }
            setAgreementData(agreements);
        }
    };

    /** V2 agreement detail back — prefer explicit list origin, else provider-scoped grid. */
    const getV2SharingAgreementDetailBack = () => {
        const sharingAgreementId = props.match.params.sharingAgreementId;
        if (!isV2AgreementSurface || isBlank(sharingAgreementId)) {
            return null;
        }
        const explicitBack = props.location?.state?.v2AgreementBack;
        if (isNotBlank(explicitBack?.pathname)) {
            return {
                pathname: explicitBack.pathname,
                search:
                    explicitBack.search !== undefined && explicitBack.search !== null
                        ? explicitBack.search
                        : props.location.search || '',
                providerDisplayName: explicitBack.providerName || ''
            };
        }
        const fromSelected = selectedV2SharingAgreement;
        if (isNotBlank(fromSelected?.providerAccount)) {
            return {
                pathname: `/connections/v2/provider/${fromSelected.providerAccount}`,
                providerDisplayName: fromSelected.providerAccountName || '',
                search: props.location.search || ''
            };
        }
        const fromList = sharingAgreementsV2?.find((ag) => ag.id === sharingAgreementId);
        if (isNotBlank(fromList?.providerAccount)) {
            return {
                pathname: `/connections/v2/provider/${fromList.providerAccount}`,
                providerDisplayName: fromList.providerAccountName || '',
                search: props.location.search || ''
            };
        }
        if (isNotBlank(selectedProviderId)) {
            return {
                pathname: `/connections/v2/provider/${selectedProviderId}`,
                providerDisplayName: '',
                search: props.location.search || ''
            };
        }
        return null;
    };

    const openConfirmationDialog = () => {
        if (
            isNotEmptyList(Object.keys(isAgreementInEditMode)) ||
            showAgreementCreation ||
            isNotEmptyList(newTruckAgreements) ||
            Object.keys(newShipperAgreement).length !== 0 ||
            Object.keys(editedAgreements).length !== 0 ||
            Object.keys(existingAgreementGroup).length !== 0
        ) {
            props.history.push(isV2AgreementSurface ? Constants.ROUTES.CONNECTIONS_V2 : '/connections');
        } else {
            if (parentPage === Constants.ACCOUNT_DETAILS) {
                visibilityProviderFlag(false);
            } else {
                const v2AgreementBack = getV2SharingAgreementDetailBack();
                if (v2AgreementBack) {
                    props.history.push({
                        pathname: v2AgreementBack.pathname,
                        search:
                            v2AgreementBack.search !== undefined
                                ? v2AgreementBack.search
                                : props.location.search || '',
                        ...(v2AgreementBack.providerDisplayName
                            ? { state: { providerName: v2AgreementBack.providerDisplayName } }
                            : {})
                    });
                } else {
                    props.history.push(
                        isV2AgreementSurface && isVisibilityProvider
                            ? Constants.ROUTES.SHARING_AGREEMENTS_V2
                            : isV2AgreementSurface
                                ? Constants.ROUTES.CONNECTIONS_V2
                            : Constants.ROUTES.CONNECTIONS
                    );
                }
                setSelectedV2SharingAgreement(null);
            }
        }
    };

    const handleAddSharing = () => {
        if (connectionType !== '') {
            if (
                isNotEmptyList(agreements[Constants.GPS_ONLY]) &&
                connectionType === Constants.AGREEMENT_TRUCK
            ) {
                setCloseAllPanel(true);
                updateScrollIntoGroup(Constants.GPS_ONLY);
            } else {
                setCloseAllPanel(true);
                toggleCreateConnection(true);
            }
        } else {
            toggleCreateConnection(false);
        }
    };

    const toggleConnectionStatus = () => {
        updateVisibilityConnectionStatus(connection_id, !connectionStatus);
    };

    const disableButtons = () => {
        return (
            disableOtherOperation ||
            enableConnectionAction ||
            (showCarrierConfig() && !carrierConfigExist) ||
            isNotEmptyList(Object.keys(isAgreementInEditMode)) ||
            showAgreementCreation ||
            !isWriteAccessGranted ||
            isNotEmptyList(newTruckAgreements) ||
            Object.keys(newShipperAgreement).length !== 0 ||
            Object.keys(editedAgreements).length !== 0 ||
            Object.keys(existingAgreementGroup).length !== 0
        );
    };

    const disableToggleWithoutPermissionCheck = () => {
        return (
            disableOtherOperation ||
            isNotEmptyList(Object.keys(isAgreementInEditMode)) ||
            showAgreementCreation ||
            isNotEmptyList(newTruckAgreements) ||
            Object.keys(newShipperAgreement).length !== 0 ||
            Object.keys(editedAgreements).length !== 0 ||
            Object.keys(existingAgreementGroup).length !== 0 ||
            isBlank(connection_id) ||
            isEmptyList(Object.keys(agreements))
        );
    };

    const disableToggle = () => {
        return disableButtons() || isBlank(connection_id) || isEmptyList(Object.keys(agreements));
    };

    const message = `Enabling Vehicles for sharing with ${providerName} will allow Trimble to share your customer information 
  and associated trucks that we identify as having ${providerName} engines. Upon completing the registration process with ${providerName} 
  through the Connected Diagnostics portal ${providerName} will have the ability to enable Connected Diagnostics on vehicles you have 
  authorized to share data with them on. Trimble will collect and send information when faults are detected as well as information periodically 
  during the operation of the vehicle. Trimble will not share vehicle information if it does not detect a ${providerName} 
  engine present in the vehicle.`;

    const searchBar = () => {
        const disable = disableToggleWithoutPermissionCheck();
        return (
            <div className={Styles.iconAlign}>
                {!showSearchBar ? (
                    <IconButton
                        id={'searchIcon'}
                        className={cs(Styles.searchIcon, disable && Styles.iconDisabled)}
                        onClick={() => setShowSearchBar(true)}
                        disabled={disable}
                    >
                        <SearchIcon />
                    </IconButton>
                ) : null}
                {showSearchBar ? (
                    <MuiThemeProvider theme={SEARCH_BAR_THEME}>
                        <TextField
                            id={'searchInput'}
                            disabled={disable}
                            className={Styles.searchBar}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ fontSize: '1.2rem' }} />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            disabled={disable}
                                            id={'closeIcon'}
                                            className={cs(
                                                Styles.closeIconAdornment,
                                                disable && Styles.iconDisabled
                                            )}
                                            onClick={() => clearSearchAndReset(true)}
                                        >
                                            <CloseIcon style={{ fontSize: '1.2rem' }} />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            onChange={handleSearch}
                        />
                    </MuiThemeProvider>
                ) : null}
            </div>
        );
    };

    const loadAgreement = () => {
        if (currentAccountType !== Constants.AGREEMENT_TYPE_OEM) {
            if (showAgreementCreation) {
                return <Agreement connectionTypeAgreement={connectionType} />;
            } else if (
                (!isV2AgreementSurface && isEmptyObject(agreementData)) ||
                (isV2AgreementSurface && isEmptyObject(agreementsV2))
            ) {
                return (
                    <div className={cs(Styles.noAgreements)}>
                        {searchText === ''
                            ? 'Select a Connection Type and click "Add a Sharing Agreement" to begin sending data to this Partner'
                            : 'No matching records found'}
                    </div>
                );
            }
        } else {
            if (isEmptyList(agreementData[Constants.GPS_ONLY])) {
                if (isProviderConnectionLoaded) {
                    if (isEmptyObject(selectedConnection) || isNotBlank(connection_id)) {
                        return <Agreement connectionTypeAgreement={connectionType} />;
                    }
                } else if (isNotBlank(connection_id)) {
                    return <Agreement connectionTypeAgreement={connectionType} />;
                } else {
                    return <Spinner />;
                }
            }
        }
        return null;
    };

    let agreementsPerPage = Object.keys(agreementData).length / ROWS_PER_PAGE_AGREEMENTS;

    if (redirectVisibilityProviderToInbox) {
        return <Spinner />;
    }

    return (
        <>
            <>
                <Header title="PROVIDER DETAIL" />
                <Paper className={isSystemAdmin ? Styles.customToolBar : null}>
                    <div
                        className={cs(
                            // "row justify-content-between no-gutters",
                            'row no-gutters',
                            baseCSS.subHeader
                        )}
                    >
                        <Grid container>
                            <Grid item xs={5}>
                                <div className={baseCSS.backNavigation}>
                                    <Typography
                                        onClick={() => openConfirmationDialog(true)}
                                        className={baseCSS.backNavigation}
                                    >
                                        <i
                                            className={cs(
                                                'fas fa-arrow-left',
                                                baseCSS.backNavigationIcon
                                            )}
                                        />
                                        {!isV2AgreementSurface
                                            ? 'Back to Connections'
                                            : 'Back to Sharing Agreements'}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={7}>
                                <div id={'pageTitle'}>
                                    {isSystemAdmin ? selectedAccount.name : session.accountName}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Paper>
            </>
            {!isV2AgreementSurface ? (
                <div className={cs(Styles.baseMargin)}>
                    <MuiThemeProvider theme={FILLED_INPUT_FIELD_THEME}>
                        <Paper elevation={0}>
                            {enableOperation ? (
                                <div className={cs('row')}>
                                    <div className={cs('col-md-4')}>
                                        <Paper className={Styles.baseMargin} elevation={0}>
                                            <div className={Styles.providerDetailsPanelHeader}>
                                                CONNECTION
                                            </div>
                                            <div>
                                                <PrimaryTextField
                                                    name="provider_name"
                                                    label="Provider Name"
                                                    id="provider_name"
                                                    value={providerName}
                                                />
                                            </div>
                                            <div className={cs(Styles.connectionSwitch)}>
                                                {isBlank(connection_id) ||
                                                    providerRequestStatus ===
                                                    SHARING_AGREEMENT_STATUS.PENDING ? null : providerRequestStatus ===
                                                        SHARING_AGREEMENT_STATUS.REJECTED ? (
                                                    <React.Fragment>
                                                        <PrimarySwitch
                                                            id={'connection-status-switch'}
                                                            onChange={toggleConnectionStatus}
                                                            className="Switch-light-blue"
                                                        />
                                                        {Constants.RESUBMIT_REQUEST}
                                                    </React.Fragment>
                                                ) : !disableConnectionSwitch ? (
                                                    <React.Fragment>
                                                        <PrimarySwitch
                                                            id={'connection-status-switch'}
                                                            checked={connectionStatus}
                                                            onChange={toggleConnectionStatus}
                                                            disabled={disableToggle()}
                                                            className="Switch-light-blue"
                                                        />
                                                        {connectionStatus ? 'ACTIVE' : 'INACTIVE'}
                                                    </React.Fragment>
                                                ) : null}
                                            </div>
                                            {!hideLocalElement && (
                                                <Auxiliary>
                                                    {currentAccountType.toLowerCase() !==
                                                        Constants.AGREEMENT_TYPE_OEM.toLowerCase() ? (
                                                        <>
                                                            <div className="row no-gutters">
                                                                <div className="col-sm-4">
                                                                    <MuiThemeProvider
                                                                        theme={
                                                                            STD_INPUT_FIELD_THEME
                                                                        }
                                                                    >
                                                                        <FormControl fullWidth>
                                                                            <InputLabel htmlFor="connection-type-label">
                                                                                Connection Type
                                                                            </InputLabel>
                                                                            <Select
                                                                                required
                                                                                input={
                                                                                    <Input
                                                                                        name="connection-type"
                                                                                        id="connection-type-label"
                                                                                    />
                                                                                }
                                                                                disabled={
                                                                                    disableButtons() ||
                                                                                    currentAccountType.toLowerCase() ===
                                                                                    Constants.ACCOUNT_TYPE_SHIPPER.toLowerCase() ||
                                                                                    isSystemAdmin
                                                                                }
                                                                                id="connection-type"
                                                                                name="connection-type"
                                                                                margin="dense"
                                                                                variant="standard"
                                                                                fullWidth
                                                                                displayEmpty
                                                                                value={
                                                                                    connectionType
                                                                                }
                                                                                onChange={
                                                                                    handleChange
                                                                                }
                                                                            >
                                                                                <MenuItem
                                                                                    value="select"
                                                                                    disabled
                                                                                >
                                                                                    Select a Type
                                                                                </MenuItem>
                                                                                <MenuItem
                                                                                    value={
                                                                                        Constants.AGREEMENT_SHIPPER
                                                                                    }
                                                                                    disabled={
                                                                                        !isV2AgreementSurface
                                                                                            ? !session.isTenantIdMapped
                                                                                            : false
                                                                                    }
                                                                                >
                                                                                    Shipment/GPS
                                                                                    Data
                                                                                </MenuItem>
                                                                                ) :
                                                                                {currentAccountType.toLowerCase() !==
                                                                                    Constants.ACCOUNT_TYPE_SHIPPER.toLowerCase() ? (
                                                                                    <MenuItem
                                                                                        value={
                                                                                            Constants.AGREEMENT_TRUCK
                                                                                        }
                                                                                        disabled={
                                                                                            !session.isCompanyIdMapped ||
                                                                                            isV2AgreementSurface
                                                                                        }
                                                                                    >
                                                                                        GPS Data
                                                                                        ONLY
                                                                                    </MenuItem>
                                                                                ) : null}
                                                                            </Select>
                                                                        </FormControl>
                                                                    </MuiThemeProvider>
                                                                </div>
                                                                <div className="col-sm-8 align-self-end text-right">
                                                                    <MuiThemeProvider
                                                                        theme={
                                                                            PRIMARY_BUTTON_LIGHT_OUTLINE_THEME
                                                                        }
                                                                    >
                                                                        <Button
                                                                            id={'addSharing'}
                                                                            variant="outlined"
                                                                            disabled={
                                                                                disableButtons() ||
                                                                                connectionType ===
                                                                                ''
                                                                            }
                                                                            onClick={
                                                                                handleAddSharing
                                                                            }
                                                                        >
                                                                            ADD A SHARING AGREEMENT
                                                                        </Button>
                                                                    </MuiThemeProvider>
                                                                </div>
                                                            </div>
                                                            {showCarrierConfig() && (
                                                                <div
                                                                    className="col-sm-12"
                                                                    style={{
                                                                        padding: '30px 0 10px 0'
                                                                    }}
                                                                >
                                                                    <Paper
                                                                        className={
                                                                            Styles.baseMargin
                                                                        }
                                                                        elevation={3}
                                                                        sx={{ marginTop: '20px' }}
                                                                    >
                                                                        <div className="row">
                                                                            <CarrierConfig
                                                                                connectionTypeAgreement={
                                                                                    connectionType
                                                                                }
                                                                                enableConnectionOperation={
                                                                                    enableConnectionOperation
                                                                                }
                                                                                type={providerName}
                                                                            />
                                                                        </div>
                                                                    </Paper>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div className="row no-gutters">
                                                            <div className="col-sm-12">
                                                                <div className={Styles.oemHelper}>
                                                                    {message}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Auxiliary>
                                            )}
                                        </Paper>
                                    </div>
                                    <div className={cs('col-md-8', Styles.agreementDetailsPanel)}>
                                        {showSpinner ? (
                                            <div className={cs(Styles.defaultHeight)}>
                                                <Spinner description={currentOperation} />
                                            </div>
                                        ) : (
                                            <Auxiliary>
                                                <div
                                                    id={'agreementCount'}
                                                    className={cs(
                                                        Styles.agreementDetailsPanelHeader
                                                    )}
                                                >
                                                    {currentAccountType ===
                                                        Constants.AGREEMENT_TYPE_OEM
                                                        ? 'OEM AGREEMENT'
                                                        : `${!isV2AgreementSurface
                                                            ? Object.keys(agreementData)
                                                                .length
                                                            : agreementsV2.length
                                                        } SHARING AGREEMENT(S)`}
                                                    {searchBar()}
                                                </div>
                                                <div className={cs(Styles.defaultHeight)}>
                                                    {paginatedAgreements.length >= 1
                                                        ? paginatedAgreements.map(
                                                            (agreementGroup, index) =>
                                                                agreementData[agreementGroup] && (
                                                                    <Agreement
                                                                        key={index}
                                                                        groupName={
                                                                            agreementData[
                                                                                agreementGroup
                                                                            ][0]?.group_name
                                                                        }
                                                                        connectionTypeAgreement={
                                                                            agreementData[
                                                                                agreementGroup
                                                                            ][0]?.agreement_type
                                                                        }
                                                                        agreementList={
                                                                            agreementData[
                                                                            agreementGroup
                                                                            ]
                                                                        }
                                                                        hideLocalElement={
                                                                            hideLocalElement
                                                                        }
                                                                    />
                                                                )
                                                        )
                                                        : null}

                                                    {loadAgreement()}
                                                </div>
                                                <div className={'offset-6'}>
                                                    <Pagination
                                                        count={
                                                            agreementsPerPage % 1 !== 0
                                                                ? Math.round(agreementsPerPage) <
                                                                    agreementsPerPage
                                                                    ? Math.round(
                                                                        agreementsPerPage
                                                                    ) + 1
                                                                    : Math.round(agreementsPerPage)
                                                                : agreementsPerPage
                                                        }
                                                        showFirstButton
                                                        showLastButton
                                                        variant="outlined"
                                                        onChange={handlePageChange}
                                                        color="primary"
                                                    />
                                                </div>
                                            </Auxiliary>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className={cs(Styles.defaultHeight)}>
                                    <Spinner description={currentOperation} />
                                </div>
                            )}
                        </Paper>
                    </MuiThemeProvider>
                </div>
            ) : (
                <SharingAgreementDetailV2
                    loading={showSpinner}
                    providerName={providerName}
                    agreementsV2={sharingAgreementsV2}
                    providers={providerConfigV2}
                    createV2SharingAgreement={createV2SharingAgreement}
                    updateV2SharingAgreement={updateV2SharingAgreement}
                    getProvidersV2={getProvidersV2}
                    isReadOnly={
                        (isSystemAdmin && !isVisibilityAdmin) ||
                        (isVisibilityProvider && !session?.isCarrier)
                    }
                    isVisibilityProvider={isVisibilityProvider}
                    showSuccessBar={showSuccessBar}
                    getSharingAgreementV2ById={getSharingAgreementV2ById}
                    selectedV2SharingAgreement={selectedV2SharingAgreement}
                    selectedProviderId={selectedProviderId}
                    selectedAccount={selectedAccount}
                    session={session}
                />
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        currentAccountType: state.connection.currentAccountType,
        connectionType: state.connection.connectionType,
        agreements: state.agreement.agreements,
        isEmptyAgreements: state.agreement.isEmptyAgreements,
        searchText: state.agreement.searchText,
        visibilityProvider: state.agreement.selectedVisibilityProvider,
        mobilityData: state.agreement.mobilityData,
        identifiers: state.agreement.identifiers,
        currentOperation: state.agreement.currentOperation,
        showSpinner: state.agreement.showSpinner,
        dataSource: state.agreement.dataSource,
        selectedConnection: state.agreement.selectedConnection,
        selectedProvider: state.agreement.selectedProvider,
        showAgreementCreation: state.agreement.showAgreementCreation,
        newShipperAgreement: state.agreement.newShipperAgreement,
        existingAgreementGroup: state.agreement.existingAgreementGroup,
        editedAgreements: state.agreement.editedAgreements,
        isAgreementInEditMode: state.agreement.isAgreementInEditMode,
        enableOperation: state.agreement.enableOperation,
        newTruckAgreements: state.agreement.newTruckAgreements,
        disableOtherOperation: state.agreement.disableOtherOperation,
        disableConnectionSwitch: state.agreement.disableConnectionSwitch,
        agreementSaved: state.agreement.agreementSaved,
        newConnectionId: state.agreement.newConnectionId,
        isProviderConnectionLoaded: state.agreement.isProviderConnectionLoaded,
        closeAllPanel: state.agreement.closeAllPanel,
        trustCenterEvents: state.agreement.trustCenterEvents,
        selectedAccountType: state.connection.selectedAccountType,
        selectedAccount: state.accounts.selectedAccount,
        sidebarResource: state.header.sidebarResource,
        session: state.session.sessionValue,
        carrierConfigExist: state.carrierConfig.carrierConfigExist,
        agreementV2List: state.agreementV2.agreementV2List,
        isTitanServiceEnabled: state.agreementV2.isTitanServiceEnabled,
        selectedProviderId: state.agreementV2.providerId,
        providers: state.agreementV2.providerSummary,
        providerConfigV2: state.agreementV2.providerConfig,
        sharingAgreementsV2: state.agreementV2.sharingAgreements,
        selectedV2SharingAgreement: state.agreementV2.selectedV2SharingAgreement,
        isCloudHubConnectorActive: state.agreementV2.isCloudHubConnectorActive,
        isCloudHubConnectorStatusLoaded: state.agreementV2.isCloudHubConnectorStatusLoaded
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDataSource: () => dispatch(actions.getDataSource()),
        setEmptyAgreements: (flag) => dispatch(actions.setEmptyAgreements(flag)),
        getMobilityData: () => dispatch(actions.getMobilityData()),
        fetchAgreements: (connectionId, selectedAccount) =>
            dispatch(actions.getAgreementsByConnectionId(connectionId, selectedAccount)),
        fetchAgreementV2: (providerAccountId) =>
            dispatch(actions.getV2SharingAgreementByProviderAccountId(providerAccountId)),
        updateFilteredAgreements: (agreements) =>
            dispatch(actions.updateFilteredAgreements(agreements)),
        getConnectionsByProviderId: (providerId, currentAccountType, session) =>
            dispatch(actions.getConnectionsByProviderId(providerId, currentAccountType, session)),
        getProviderDetails: (providerId) => dispatch(actions.getProviderDetails(providerId)),
        setCurrentPage: (pageName) => dispatch(setCurrentPage(pageName)),
        toggleCreateConnection: (showCreateConnection) =>
            dispatch(actions.toggleCreateConnection(showCreateConnection)),
        getConnectionById: (connection_id) => dispatch(actions.getConnectionById(connection_id)),
        resetConnection: () => dispatch(actions.resetConnection()),
        resetUserInputs: () => dispatch(actions.resetAllData(true)),
        updateScrollIntoGroup: (groupName) => dispatch(actions.updateScrollIntoGroup(groupName)),
        updateSearchText: (searchText) => dispatch(actions.updateSearchText(searchText)),
        updateVisibilityConnectionStatus: (connectionId, status) =>
            dispatch(actions.updateVisibilityConnectionStatus(connectionId, status)),
        storeNewConnectionId: (connection_id) => {
            dispatch(actions.storeNewConnectionId(connection_id));
        },
        updateCurrentAccountType: (type) => {
            dispatch(actions.updateCurrentAccountType(type));
        },
        updateConnectionType: (type) => {
            dispatch(actions.updateConnectionType(type));
        },
        toggleAgreementSaveFlag: (flag) => dispatch(actions.toggleAgreementSaveFlag(flag)),
        setCloseAllPanel: (flag) => dispatch(actions.setCloseAllPanel(flag)),
        getTrustCenterEventTypes: (providerType, destinationAccountId) =>
            dispatch(actions.getTrustCenterEventTypes(providerType, destinationAccountId)),
        createV2SharingAgreement: (agreementV2, onSuccess) =>
            dispatch(actions.createV2SharingAgreement(agreementV2, onSuccess)),
        updateV2SharingAgreement: (agreementV2, onSuccess, onError) =>
            dispatch(actions.updateV2SharingAgreement(agreementV2, onSuccess, onError)),
        getProvidersV2: () => dispatch(actions.getProvidersV2()),
        showSuccessBar: (message) => dispatch({ type: SHOW_SUCCESS_BAR, payload: message }),
        getSharingAgreementV2ById: (id) => dispatch(getV2SharingAgreementById(id)),
        setSelectedV2SharingAgreement: (agreement) =>
            dispatch(actions.setSelectedV2SharingAgreement(agreement)),
        getCloudHubConnectorStatus: (accountId) =>
            dispatch(actions.getCloudHubConnectorStatus(accountId))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProviderDetail));
